import api from 'api';

export const loadCreativeStatuses = api(
  'GET /api/tracker/creative-filters/statuses'
);

export const loadCreativeCreatedBy = api(
  'GET /api/tracker/creative-filters/created-by'
);

export const loadCreativeTypes = api(
  'GET /api/tracker/creative-filters/creative-types'
);

export const loadCreativeLanguages = api(
  'GET /api/tracker/creative-filters/languages'
);

export const loadCreativeMediaTypes = api(
  'GET /api/tracker/creative-filters/media-types'
);

export const loadCreativeOrientations = api(
  'GET /api/tracker/creative-filters/orientations'
);

export const loadCreativeRequestedBy = api(
  'GET /api/tracker/creative-filters/requested-by'
);

export const loadCreativeResolutions = api(
  'GET /api/tracker/creative-filters/resolutions'
);

export const loadCreativeSizes = api('GET /api/tracker/creative-filters/sizes');

export const loadCreativeAuthors = api(
  'GET /api/tracker/creative-filters/authors'
);

export const loadCreativeProductionTypes = api(
  'GET /api/tracker/creative-filters/production-types'
);

export const loadCreativeEnhancers = api(
  'GET /api/tracker/creative-filters/enhancers'
);

export const loadCreativeOS = api('GET /api/tracker/creative-filters/os');

export const loadCreativeColors = api(
  'GET /api/tracker/creative-filters/colors'
);

export const loadCreativeIncludedTags = api(
  'GET /api/tracker/creative-filters/included-tags'
);

export const loadCreativeExcludedTags = api(
  'GET /api/tracker/creative-filters/excluded-tags'
);

export const loadCreativeAiCreatedTypes = api(
  'GET /api/tracker/creative-filters/ai-created-types'
);

export const loadEndCards = api('GET /api/tracker/creative-filters/end-cards');

export const loadTested = api('GET /api/tracker/filters/tested');
